import React from "react";
import { Route, Switch } from "react-router";
import Loadable from "react-loadable";
import Loading from "./components/Loading";

const Home = Loadable({
  loader: () => import("./containers/Home"),
  loading: Loading,
});

const Dashboard = Loadable({
  loader: () => import("./containers/Dashboard"),
  loading: Loading,
});

const Schedule = Loadable({
  loader: () => import("./components/Schedule"),
  loading: Loading,
});

const Dentists = Loadable({
  loader: () => import("./components/Dentists"),
  loading: Loading,
});

const Practice = Loadable({
  loader: () => import("./components/Practice"),
  loading: Loading,
});
const YearView = Loadable({
  loader: () => import("./components/YearView"),
  loading: Loading,
});

const Notes = Loadable({
  loader: () => import("./components/Notes"),
  loading: Loading,
});

const ChangeRequests = Loadable({
  loader: () => import("./components/ChangeRequests"),
  loading: Loading,
});

const OverrideDays = Loadable({
  loader: () => import("./components/OverrideDays"),
  loading: Loading,
});

const NotAuthorize = Loadable({
  loader: () => import("./components/NotAuthorize"),
  loading: Loading,
});

const ManageHelpView = Loadable({
  loader: () => import("./containers/ManageHelpView"),
  loading: Loading,
});

const Usage = Loadable({
  loader: () => import("./containers/Usage"),
  loading: Loading,
});

const SubstituteCosts = Loadable({
  loader: () => import("./components/SubstituteCosts"),
  loading: Loading,
});
const OpenCloseMismatch = Loadable({
  loader: () => import("./components/Reports"),
  loading: Loading,
});
const TsTeMismatchReport = Loadable({
  loader: () => import("./components/Reports/tsTeMismatchReport"),
  loading: Loading,
});
const DoctorWorkHistory = Loadable({
  loader: () => import("./components/Reports/doctorWorkHostory"),
  loading: Loading,
});
const ScheduleChangeComments = Loadable({
  loader: () => import("./components/Reports/scheduleChangeComments"),
  loading: Loading,
});

const DefaultSubCosts = Loadable({
  loader: () => import("./components/DefaultSubCosts"),
  loading: Loading,
});

const Login = Loadable({
  loader: () => import("./containers/Login"),
  loading: Loading,
});

const routes = (
  <div>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/not-authorize" component={NotAuthorize} />
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/schedule/:month?/:year?" component={Schedule} />
      <Route path="/dentists" component={Dentists} />
      <Route path="/practice" component={Practice} />
      <Route path="/yearview" component={YearView} />
      <Route path="/notes" component={Notes} />
      <Route path="/change-requests" component={ChangeRequests} />
      <Route path="/overrides" component={OverrideDays} />
      <Route path="/manage-help" component={ManageHelpView} />
      <Route path="/usage" component={Usage} />
      <Route path="/substitute-costs" component={SubstituteCosts} />
      <Route
        path="/reports/open-close-mismatch"
        component={OpenCloseMismatch}
      />
      <Route path="/reports/ts-te-mismatch" component={TsTeMismatchReport} />
      <Route
        path="/reports/doctor-work-history"
        component={DoctorWorkHistory}
      />
      <Route
        path="/reports/schedule-change-comments"
        component={ScheduleChangeComments}
      />
      <Route path="/default-sub-costs" component={DefaultSubCosts} />
      <Route path="/cdpLogin/:token" component={Home} />
      <Route path="/login" component={Login} />
    </Switch>
  </div>
);

export default routes;
